// @flow strict

export type EmploymentStatus =
  | 'not_employed'
  | 'self_employed'
  | 'student'
  | 'part_time'
  | 'full_time'
  | 'retired'

export type ResidentialStatus =
  | 'tenant'
  | 'mortgage'
  | 'no-mortgage'
  | 'living-with-parents'
  | 'other'

export type NumDependent = '0' | '1' | '2' | '3' | '4' | '5' | '6'

export type RightToReside = 'temporary' | 'indefinite' | 'no-right'

export type FormState = {
  age: string,
  employmentStatus: EmploymentStatus,
  residentialStatus: ResidentialStatus,
  postcode: string,
  income: string,
  reducedIncome: string,
  housingExpenditure: string,
  numDependents: string,
  existingDebt: {
    creditBalance: string,
    overdraftBalance: string,
    fixedMonthlyPayments: string,
  },
  desiredLimit: number,
  hasPreviousCredit?: 'Yes' | 'No',
  hasPreviousJudgementOrDefault?: 'Yes' | 'No',
  hasMissedPayments?: 'Yes' | 'No',
  ukNational?: 'Yes' | 'No',
  rightToReside?: RightToReside,
  rightToResideExpiry?: number,
}

export type CheckEligibilityRequest = {
  age: number,
  employment_status: EmploymentStatus,
  residential_status: ResidentialStatus,
  postcode: string,
  residential_status: string,
  housing_expenditure_amount: number,
  housing_expenditure_currency: string,
  gross_annual_income_amount: number,
  gross_annual_income_currency: string,
  has_reduced_annual_income: boolean,
  reduced_annual_income_amount: number,
  reduced_annual_income_currency: string,
  num_dependents: number,
  existing_debt: {
    revolving_credit_balance_amount: number,
    revolving_credit_balance_currency: string,
    monthly_fixed_payments_amount: number,
    monthly_fixed_payments_currency: string,
  },
  has_existing_credit: boolean,
  has_ccj_or_defaults: boolean,
  has_missed_payments: boolean,
  uk_national: boolean,
  right_to_reside?: string,
  right_to_reside_expiry?: number,

  limit: number,
}

export type FormResult = {
  eligibility:
    | 'ineligible'
    | 'very_unlikely'
    | 'potentially_eligible'
    | 'oops'
    | 'not_available',
  eligibility_explanation: string,
}

export const prettyFormResult = {
  ineligible: 'Not Eligible',
  very_unlikely: 'Very Unlikely',
  potentially_eligible: 'Potentially Eligible',
  not_available: 'Not available (just yet)',
  oops: 'Oops',
}
